import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { hasFeatureFlags } from 'utils/features';
import Modal from 'components/AssignModal/Modal';
import ActionMessage from './ActionMessage';
import { AssociatedContent } from './types';
import Button from '../../../ui/Button';

const AssignContent = ({
  assignAllContent,
  sessions,
  associatedContent,
  event,
  attendances,
  timeZones,
  currentSessionId,
  attendedGuestList,
}) => {
  const { contentItems, loading } = associatedContent;
  const currentSession = sessions.find(
    session => Number(session.id) === Number(currentSessionId),
  );

  const isDisabled = currentSession && !currentSession.session_ended;

  const [isVisible, setIsVisible] = useState(false);
  const allUnassignedContent = [];
  let eventData = {};
  const assigneesList = [];
  const hasPopulateAssignModalEnabled = hasFeatureFlags([
    'learning_populate_assign_modal',
  ]);
  const allContentAssigned =
    !isDisabled &&
    !!contentItems.length &&
    contentItems.every(item => item.assigned_at);
  const content = contentItems.filter(item => item.assigned_at === null);

  attendedGuestList.forEach(guest => {
    assigneesList.push({
      id: guest.id,
      type: 'User',
      meta: {},
      name: guest.name,
    });
  });

  if (hasPopulateAssignModalEnabled) {
    content.forEach(item => {
      allUnassignedContent.push({
        id: item.id,
        type: item.type,
        meta: {},
        title: item.title,
      });
    });

    eventData = allUnassignedContent && {
      allUnassignedContent,
      assigneesList,
      schedule: {
        assignDate: null,
        assignTime: '08:00',
        timeZone: 'Eastern Time (US & Canada)',
        dueDate: null,
      },
    };
  }

  const toggleContainer = () => {
    setIsVisible(!isVisible);
  };

  const renderTooltip = () => {
    if (event.is_archived) {
      return t('in_person_training.event_content.disabled_archived');
    }
    if (attendedGuestList.length === 0) {
      return t(
        'in_person_training.event_content.disabled_user_attendance_unconfirmed',
      );
    }
    return t('in_person_training.event_content.disabled_event_not_ended');
  };

  const state = {
    meta: {
      features: {
        resource_experiment: hasFeatureFlags('resource_experiment'),
      },
      i18n: {
        smart_groups_calculation_tooltip: t(
          'assign_modal.smart_groups_calculation_tooltip',
        ),
        invalid_group_tooltip: t(
          'smart_groups.blank_slates.invalid.description',
        ),
        button_text: t('actions.assign'),
        assign_error_message: t('assign_modal.assign_error_message'),
      },
    },
  };

  return (
    !loading &&
    !!contentItems.length && (
      <div className="mt-16">
        {!hasPopulateAssignModalEnabled &&
          (allContentAssigned ? (
            <ActionMessage
              message={
                event.is_archived
                  ? t(
                      'in_person_training.event_content.success_message_archived',
                    )
                  : t('in_person_training.event_content.success_message')
              }
            />
          ) : (
            <Button
              customColor
              onClick={() => assignAllContent(currentSessionId)}
              a11yDisabled={
                isDisabled ||
                event.is_archived ||
                attendedGuestList.length === 0
              }
              a11yDisabledTooltip={renderTooltip()}
            >
              {t('in_person_training.event_content.assign_to_attendees')}
            </Button>
          ))}
        {hasPopulateAssignModalEnabled &&
          !allContentAssigned &&
          allUnassignedContent.length > 0 && (
            <Button
              customColor
              onClick={toggleContainer}
              a11yDisabled={
                isDisabled ||
                event.is_archived ||
                attendedGuestList.length === 0
              }
              a11yDisabledTooltip={renderTooltip()}
            >
              {t('in_person_training.event_content.assign_to_attendees')}
            </Button>
          )}
        {isVisible && (
          <Modal
            toggleContainer={toggleContainer}
            eventData={eventData}
            timeZones={timeZones}
            assignAllContent={assignAllContent}
            currentSessionId={currentSessionId}
            state={state}
          />
        )}
      </div>
    )
  );
};

const mapStateToProps = ({ attendees }) => ({
  attendances: attendees.attendances,
  attendedGuestList: attendees.attendances.attendedGuestList,
});

AssignContent.propTypes = {
  associatedContent: AssociatedContent,
  assignAllContent: PropTypes.func,
  sessions: PropTypes.arrayOf(PropTypes.shape({})),
  event: PropTypes.shape({}),
};

export default connect(mapStateToProps)(AssignContent);
